<template>
  <div class="hello">
    <van-card
      v-if="isSign"
      :desc="signInfo.gender == '1' ? '男' : '女'"
      :title="signInfo.residentName"
      :thumb="avatarImg"
    >
      <template #tags>
        <van-tag plain type="success">已签约</van-tag>
        <div class="tagbox">
          <span>签约机构：{{ signInfo.orgName }}</span>
          <span>签约团队：{{ signInfo.teamName }}</span>
          <span>签约医生：{{ signInfo.userName }}</span>
          <span style="display: flex;align-items: center;"
            >阿福医生：{{ signInfo.promoteDoctorsName
            }}<van-button
              :style="{
                marginLeft: signInfo.promoteDoctorsName ? '10px' : '0px',
              }"
              plain
              type="primary"
              icon="setting-o"
              size="mini"
              @click="changePromoteDoctor()"
              >{{ signInfo.promoteDoctorsName ? "修改" : "设置" }}</van-button
            ></span
          >
        </div>
      </template>
    </van-card>
    <van-card v-else :thumb="avatarImg">
      <template #tags>
        <p style="font-size: 16px;">{{ realInfo.certName }}</p>
        <van-tag plain type="danger" v-if="!signInfo.signApplyMsg"
          >未签约</van-tag
        >
        <van-tag plain type="danger" v-if="signInfo.signApplyMsg">{{
          signInfo.signApplyMsg
        }}</van-tag>
      </template>
    </van-card>
    <van-empty description="未查询到签约信息" v-show="!isSign"> </van-empty>
    <van-button
      v-if="signCode == 4 || signCode == 0"
      round
      plain
      type="primary"
      id="btn"
      @click="handleClick"
    >
      {{ isSign ? "查看签约详情" : "去签约" }}
    </van-button>
    <van-button
      v-if="signCode == 200 || signCode == 500"
      round
      plain
      type="primary"
      id="btn"
      @click="handleClick"
    >
      {{ isSign ? "查看签约详情" : "去签约" }}
    </van-button>

    <van-popup
      v-model="showPromotePopup"
      position="bottom"
      round
      :style="{ height: '70%' }"
    >
      <div class="promote-popup">
        <div class="promote-popup__header">选择阿福医生</div>
        <van-radio-group v-model="selectedPromoteDoctorId">
          <div class="promote-list">
            <van-radio
              v-for="item in promoteDoctorList"
              :key="item.userNo || item.realname"
              :name="item.userNo"
              class="promote-item"
            >
              {{ item.realname }}
            </van-radio>
          </div>
        </van-radio-group>
        <div class="promote-popup__footer">
          <van-button plain type="primary" @click="showPromotePopup = false">
            关闭
          </van-button>
          <van-button type="primary" @click="confirmPromoteDoctor">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Card,
  Tag,
  Button,
  Empty,
  Popup,
  RadioGroup,
  Radio,
  Toast,
} from "vant";
import avatarImg from "@/assets/img/tx.png";
import api from "@/services/api/api";

export default {
  name: "HelloWorld",
  components: {
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Empty.name]: Empty,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Toast.name]: Toast,
  },
  props: {
    signInfo: {
      type: Object,
      default: () => {},
    },
    isSign: {
      type: Boolean,
      default: () => false,
    },
    realInfo: {
      type: Object,
      default: () => {},
    },
    signCode: {
      type: Number,
      default: () => null,
    },
    appId: {
      type: String,
      default: () => null,
    },
    aqOpenId: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      avatarImg: avatarImg,
      showPromotePopup: false,
      promoteDoctorList: [],
      selectedPromoteDoctorId: null,
    };
  },
  methods: {
    changePromoteDoctor() {
      const obj = {
        orgNo: this.signInfo.orgNo,
        appId: this.appId,
        pageSize: 1000,
        pageNum: 1,
      };
      api.getOrgAllDoctor(obj).then((res) => {
        if (res.code === 200) {
          this.promoteDoctorList = res.rows || [];
          this.selectedPromoteDoctorId = this.signInfo.promoteDoctorsId || null;
          this.showPromotePopup = true;
        }
      });
    },
    confirmPromoteDoctor() {
      const selectedDoctor = this.promoteDoctorList.find(
        (item) => item.userNo === this.selectedPromoteDoctorId,
      );

      if (selectedDoctor) {
        const params = {
          appId: this.appId,
          aqOpenId: this.aqOpenId,
          identity: this.signInfo.identity || this.realInfo.certNo || "",
          promoteDoctorsId: selectedDoctor.userNo,
          promoteDoctorsName: selectedDoctor.realname,
        };

        api.setPromoteDoctor(params).then((res) => {
          const resCope = JSON.parse(res);
          if (resCope.code == "1") {
            Toast.success(resCope.data);
            this.signInfo.promoteDoctorsName = selectedDoctor.realname;
            this.signInfo.promoteDoctorsId = selectedDoctor.userNo;
          }
        });
      }

      this.showPromotePopup = false;
    },
    handleClick() {
      this.$emit("viewDetail");
    },
  },
};
</script>

<style scoped>
.van-card {
  border-radius: 5px;
  padding: 20px 15px;
}
.van-card__title {
  font-size: 16px;
}
.van-card__desc {
  font-size: 14px;
  margin: 5px 0;
}
.van-card__content {
  text-align: left;
}
.van-tag--plain {
  font-size: 14px;
  padding: 4px 4px;
}
.van-empty {
  padding: 0;
}
.hello {
  padding-top: 30px;
}
.tagbox {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  line-height: 25px;
  font-size: 15px;
}
#btn {
  margin-top: 20px;
  min-width: 160px;
}

.promote-popup {
  padding: 16px;
}

.promote-popup__header {
  font-size: 16px;
  margin-bottom: 12px;
}

.promote-list {
  max-height: 330px;
  overflow-y: auto;
  font-size: 16px;
}

.promote-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.promote-popup__footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}
</style>
